wbApp.directive('wbValidationTooltip', ['$tooltip', '$timeout', 'errorTypeTranslateSvc',
    function ($tooltip, $timeout, errorTypeTranslateSvc) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {

            var errorTooltip = $tooltip(elem,
                {
                    title: "",
                    trigger: "hover focus",
                    placement: attr.wbValidationTooltip || "auto bottom",
                    html: true,
                    animation: "am-fade-and-scale",
                    delay: 100
                });

            scope.$watch(function () { return elem.attr('class'); },
                function (validity) {
                    var errors = '';

                    if (/*ctrl.$dirty && */!ctrl.$valid) {
                        for (var error in ctrl.$error) {
                            if (!ctrl.$error[error]) {
                                continue;
                            }

                            if (errors.length) {
                                errors += '<br/>';
                            }

                            errors += errorTypeTranslateSvc.translate(error, attr, scope);
                        }

                        if (errorTooltip.$scope.title !== errors) {
                            var hasFocus = $(elem).is(":focus");

                             errorTooltip.$scope.title = errors;

                            if (hasFocus) {
                                errorTooltip.show();
                            }
                        }
                    }
                    else {
                        errorTooltip.$scope.title = "";
                    }
                });
        }
    };
}]);